import React, { useState } from "react"
import { Button } from "react-bootstrap"
import { FaPlus } from "react-icons/fa"
import EmailTemplateCard from "./EmailTemplateCard"
import NewEmailModal from "./NewEmailModal"
import axios from "axios"
import { localserver } from "../../../api/common"
import { showToast } from "../../Shared/ToastMessage"
import { useUser } from '../../AdminUsers/UserContext';
const EmailAttendees = ({ isLoading, emailTemplates, activeTab, fetchEmailsTemplate }) => {

  const { checkPermission, getValidation } = useUser();
  const [showNewEmailModal, setShowNewEmailModal] = useState(false)
  const [selectedEmail, setSelectedEmail] = useState(null)

  // Map activeTab to email_type
  const getEmailType = (tab) => {
    switch (tab) {
      case "attendees":
        return 1
      case "orders":
        return 2
      case "prepaidOrders":
        return 3
      case "reminders":
        return 4
      default:
        return 1
    }
  }

  const handleToggleActive = async(templateId, status) => {
    console.log(`Toggle active for email ${templateId} in ${activeTab}`)
    try {
      const hasPermission = await checkPermission("Email Settings", "update");
      if (!hasPermission) return;
      const newStatus = !status;
      const response = await axios.post(
        `${localserver}/updateEmailTemplateStatus`,
        {
          id:templateId,
          is_active:newStatus?1:0
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        },
      )

      if (response.data.success) {
        showToast(response.data.message, "success")
        fetchEmailsTemplate(activeTab)
      } else {
        showToast(response.data.message, "error")
        console.error(response.data.message, "error")
      }
    } catch (error) {
      console.error(`Error :`, error)
    }
  }

  const handleOpenNewEmailModal = async() => {
    const hasPermission = await checkPermission("Email Settings", "create");
    if (!hasPermission) return;
    setSelectedEmail(null) // Clear selected email for new email creation
    setShowNewEmailModal(true)
  }

  const handleCloseNewEmailModal = () => {
    setShowNewEmailModal(false)
    setSelectedEmail(null)
    fetchEmailsTemplate(activeTab)
  }

  const handleEditEmail = async(template) => {
    const hasPermission = await checkPermission("Email Settings", "update");
    if (!hasPermission) return;
    // const template = emailTemplates.find((t) => t.id === id);
    console.log("template: ", template)
    if (template) {
      // const emailData = {
      //   id: template.id,
      //   event_id: localStorage.getItem("eventId"),
      //   email_type: getEmailType(activeTab),
      //   title: template.title,
      //   trigger_function: "On successful registration",
      //   target: 1, // Individual
      //   target_array: "",
      //   schedule_date: "",
      //   subject_line: "",
      //   email_content: "<p>{{Event.Date}}</p><p>{{Event.Title}}</p>",
      //   sender_email: template.sendTo || "",
      //   sender_name: "",
      //   reply_to_email: "",
      //   cc_emails: "",
      // };
      setSelectedEmail(template)
      setShowNewEmailModal(true)
    }
  }

  const handleCloneEmail = (id) => {
    const templateToClone = emailTemplates.find((template) => template.id === id)
    if (templateToClone) {
      // Construct emailData for cloning without fetching
      const emailData = {
        event_id: localStorage.getItem("eventId"),
        email_type: getEmailType(activeTab),
        title: `${templateToClone.title} (Clone)`,
        trigger_function: "On successful registration",
        target: 1, // Individual
        target_array: "",
        schedule_date: "",
        subject_line: "",
        email_content: "<p>{{Event.Date}}</p><p>{{Event.Title}}</p>",
        sender_email: templateToClone.sendTo || "",
        sender_name: "",
        reply_to_email: "",
        cc_emails: "",
      }
      console.log(`Clone email ${id} in ${activeTab}`, emailData)
      setSelectedEmail(emailData)
      setShowNewEmailModal(true)
    }
  }

  const handleRenameEmail = (id) => {
    console.log(`Rename email ${id} in ${activeTab}`)
    // Implement rename functionality
  }

  const handleDeleteEmail = async (deleteId) => {
    console.log(`Delete email ${deleteId} in ${activeTab}`)
    try {
      const hasPermission = await checkPermission("Email Settings", "delete");
      if (!hasPermission) return;
      const response = await axios.post(
        `${localserver}/deleteEmailTemplate`,
        {
          id: deleteId,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          },
        },
      )

      if (response.data.success) {
        showToast(response.data.message, "success")
      } else {
        showToast(response.data.message, "error")
        console.error(response.data.message, "error")
      }
    } catch (error) {
      console.error(`Error :`, error)
    }
  }

  // Map activeTab to a user-friendly heading
  const getHeading = () => {
    switch (activeTab) {
      case "attendees":
        return "Attendees"
      case "orders":
        return "Orders"
      case "prepaidOrders":
        return "Prepaid Orders"
      case "reminders":
        return "Reminders"
      default:
        return "Attendees"
    }
  }

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h4 className="mb-0 email-heading">{getHeading()}</h4>
        <Button variant="outline-primary" className="d-flex align-items-center" onClick={handleOpenNewEmailModal}>
          <FaPlus className="mr-2" /> New Email
        </Button>
      </div>

      {isLoading ? (
        <div>Loading email templates...</div>
      ) : emailTemplates && emailTemplates.length > 0 ? (
        emailTemplates.map((template) => (
          <EmailTemplateCard
            key={template.id}
            id={template.id}
            title={template.title}
            description={template.description}
            sendTo={template.sendTo}
            excluding={template.excluding}
            isActive={template.isActive}
            onToggleActive={() => handleToggleActive(template.id, template.isActive)}
            onEdit={() => handleEditEmail(template)}
            onClone={() => handleCloneEmail(template.id)}
            onRename={() => handleRenameEmail(template.id)}
            onDelete={() => handleDeleteEmail(template.id)}
          />
        ))
      ) : (
        <div>No email templates found for {getHeading().toLowerCase()}.</div>
      )}

      <NewEmailModal
        show={showNewEmailModal}
        handleClose={handleCloseNewEmailModal}
        emailData={selectedEmail || { email_type: getEmailType(activeTab) }}
        emailType={activeTab}
        getValidation={getValidation}
      />
    </>
  )
}

export default EmailAttendees
